import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";
export default class FileCommentsService extends ApiService {
  namespace = "file-comments";
  icon = "Comment";
  name = "Type";
  favicon = "Comment";
  Width = 690;
  domain = DOMAIN.FILE_COMMENTS;
  action = "action";
  constructor() {
    super("comments");
  }
}
